/* eslint-disable react/jsx-no-bind */
import React from "react";
import { FormattedMessage, useIntl } from "react-intl";
import Skeleton from "react-loading-skeleton";
import { RadioSelect } from "./Form";
import { List, Tree } from "./List";
import { isTouchDevice } from "../utils";
import { SearchBar } from "./Search";
import { Column, Container, Row } from "./Grid";
import Chips from "./Chips/Chips";
import Icon from "./Icon";

type Props = {
  itemKey: "categories" | "languages";
  title: string;
  topItemsLabel?: string;
  moreItemsLabel?: string;
  includeNoItems?: boolean;
  values: {
    selectedSwitch?: string;
    selectedItems?: {
      id: string | number;
      name: string;
      code: string;
    }[];
  };
  allItems?: $TSFixMe[];
  topItems?: $TSFixMe[];
  handleSpecificSelectionChange: $TSFixMeFunction;
  handleSelectionSwitch: $TSFixMeFunction;
  withTreeView?: boolean;
};

function AllOrMultipleSelect({
  values,
  allItems,
  topItems,
  itemKey,
  title,
  handleSpecificSelectionChange,
  handleSelectionSwitch,
  moreItemsLabel,
  topItemsLabel,
  withTreeView,
  includeNoItems = true,
}: Props) {
  const intl = useIntl();
  const [searchTerm, setSearchTerm] = React.useState("");
  const [selectedItems, setSelectedItems] = React.useState([]);

  React.useEffect(() => {
    // @ts-expect-error TS(2345) FIXME: Argument of type '{ id: string | number; name: str... Remove this comment to see the full error message
    setSelectedItems(values.selectedItems);
  }, []);

  React.useEffect(() => {
    handleSpecificSelectionChange(selectedItems);
  }, [selectedItems]);

  const newAllItems = allItems
    ? [...allItems.map((item) => ({ ...item, code: item.name }))]
    : undefined;
  if (includeNoItems && newAllItems) {
    const noItemLabel = intl.formatMessage({
      id: `export_files_dialog.no_${itemKey}`,
    });
    if (!newAllItems?.find((item) => item.id === "null")) {
      newAllItems?.unshift({
        id: "null",
        code: "null",
        name: noItemLabel,
        // @ts-expect-error TS(2345) FIXME: Argument of type 'string' is not assignable to par... Remove this comment to see the full error message
        checked: selectedItems?.includes("null"),
        tenant: undefined,
      });
    }
  }

  const filteredItems = searchTerm
    ? newAllItems?.filter((item) =>
        item.name.toLowerCase().includes(searchTerm.toLowerCase()),
      )
    : newAllItems;

  const onChipRemove = (selectedItemIdToRemove: $TSFixMe) => {
    const newSelectedItems = [...selectedItems];
    setSelectedItems(
      newSelectedItems.filter(
        (selectedItem) =>
          (selectedItem as $TSFixMe).id.toString() !==
          selectedItemIdToRemove.toString(),
      ),
    );
  };

  const handleListItemClicked = (itemId: $TSFixMe) => {
    const foundItem = selectedItems.find(
      (item) => (item as $TSFixMe).id.toString() === itemId,
    );
    if (foundItem) {
      const tempSelected = selectedItems.filter(
        (item) => (item as $TSFixMe).id.toString() !== itemId,
      );
      setSelectedItems([...tempSelected]);
    } else {
      // @ts-expect-error TS(2461) FIXME: Type 'any[] | undefined' is not an array type.
      const itemToAdd = [...newAllItems, ...(topItems || [])].find(
        (item) => item.id.toString() === itemId,
      );
      // @ts-expect-error TS(2322) FIXME: Type 'any' is not assignable to type 'never'.
      setSelectedItems([...selectedItems, itemToAdd]);
    }
  };

  function renderListItem(
    id: $TSFixMe,
    name: $TSFixMe,
    checked: $TSFixMe,
    tenant: $TSFixMe,
  ) {
    const enabled =
      values.selectedSwitch !== "specific_selection"
        ? ""
        : "tenant-option-enabled";
    const isEndress =
      tenant?.name && tenant?.public ? (
        <span className={`tenant-option-icon ${enabled}`}>
          <Icon name="icon3-eh-radio-button-checked" />
        </span>
      ) : null;

    const tenantContent =
      tenant?.name && !tenant?.public ? ` (${tenant?.name})` : null;

    return (
      <div key={`checkbox-${id}`} className="all-or-multiple-select-list-item">
        <input
          id={`${itemKey}-${id}-checkbox`}
          type="checkbox"
          className={checked ? "checked" : "unchecked"}
          checked={checked}
          value={id}
          onChange={(e) => handleListItemClicked(e.target.value)}
          disabled={values.selectedSwitch !== "specific_selection"}
        />
        <label htmlFor={`${itemKey}-${id}-checkbox`}>
          <span id={id}>{name}</span>
          {tenantContent}
          {isEndress}
        </label>
      </div>
    );
  }

  function onSelectionSwitch(value: $TSFixMe) {
    if (value === "all") {
      setSelectedItems([]);
    }
    handleSelectionSwitch(value);
  }

  const isLoading = !newAllItems;
  const isChecked = (id: $TSFixMe) =>
    !!selectedItems?.find(
      (item) => (item as $TSFixMe).id.toString() === id.toString(),
    );

  return (
    <>
      <h3>{title}</h3>
      <RadioSelect
        id={`${itemKey}-items-switch`}
        options={[
          { value: "all", label: intl.formatMessage({ id: "label.all" }) },
          {
            value: "specific_selection",
            label: intl.formatMessage({ id: "label.specific_selection" }),
          },
        ]}
        // @ts-expect-error TS(2322) FIXME: Type '{ id: string; options: { value: string; labe... Remove this comment to see the full error message
        handleChange={(e: $TSFixMe) => onSelectionSwitch(e.target.value)}
        values={{ "items-type": values.selectedSwitch }}
        name="items-type"
        handleBlur={() => true}
      />
      <SearchBar
        // @ts-expect-error TS(2322) FIXME: Type '{ autoFocus: boolean; disabled: boolean; fil... Remove this comment to see the full error message
        autoFocus={!isTouchDevice()}
        disabled={values.selectedSwitch !== "specific_selection"}
        filterWildcard={false}
        onSearch={(searchResult: $TSFixMe) => setSearchTerm(searchResult)}
        placeholder={intl.formatMessage({ id: "search.searchbox_placeholder" })}
        resettable
        hideSubmit
        timeout={300}
      />
      {!!selectedItems.length && (
        <Chips items={selectedItems} onRemove={onChipRemove} withTooltip />
      )}
      <Container className="all-or-multiple-select-container">
        <Row>
          <Column>
            {!isLoading &&
              (withTreeView && !searchTerm ? (
                <Tree
                  list={newAllItems}
                  selectedItems={selectedItems}
                  setSelectedItems={setSelectedItems}
                  disabled={values.selectedSwitch !== "specific_selection"}
                  showIsEndress
                />
              ) : (
                <List>
                  {!searchTerm && (
                    <>
                      {/* @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'. */}
                      {topItems?.length > 0 && (
                        <>
                          <div
                            className="all-or-multiple-select-top-more-items"
                            // @ts-expect-error TS(2322) FIXME: Type '{ children: string | undefined; className: s... Remove this comment to see the full error message
                            disabled={
                              values.selectedSwitch !== "specific_selection"
                            }
                          >
                            {topItemsLabel}
                          </div>
                          {/* @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'. */}
                          {topItems.map(({ id, name, tenant }) =>
                            renderListItem(id, name, isChecked(id), tenant),
                          )}
                        </>
                      )}
                      {/* @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'. */}
                      {filteredItems?.length > 0 && (
                        <div
                          className="all-or-multiple-select-top-more-items"
                          // @ts-expect-error TS(2322) FIXME: Type '{ children: string | undefined; className: s... Remove this comment to see the full error message
                          disabled={
                            values.selectedSwitch !== "specific_selection"
                          }
                        >
                          {moreItemsLabel}
                        </div>
                      )}
                    </>
                  )}
                  {filteredItems?.map(({ id, name, tenant }) =>
                    renderListItem(id, name, isChecked(id), tenant),
                  )}
                </List>
              ))}
            {!isLoading && searchTerm && !filteredItems?.length && (
              <div className="no-search-results-text">
                <FormattedMessage id="search.no_results_found" />
              </div>
            )}
            {isLoading && (
              <Skeleton
                containerTestId="all-or-multiple-select-skeleton"
                height={296}
              />
            )}
          </Column>
        </Row>
      </Container>
    </>
  );
}

export default AllOrMultipleSelect;
